
export const defaultState = {
  currentMood: {},
  moods: [],
  error: '',
  loading: false,
};

export default {
  ...defaultState,
};
